const area = {
    namespaced: true,
    state: {
        // 选中地区
        selectArea: {},
    },
    getters: {

    },
    mutations: {
        /** 选中地区 */
        setReady(state, value) {
            state.selectArea = value;
        },
    },
    actions: {
    }
}

export default area
